import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'rx-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {
  /** Tooltip icon**/
  @Input() icon = 'rx-question-mark';
  /** Tooltip text**/
  @Input() text: string;
  /** Tooltip position**/
  @Input() position = 'top';
  /** device type **/
  @Input() isMobile = true;

  preventClick($event: Event): void {
    $event.stopPropagation();
  }
}
